import React, { useState } from 'react';
import { createStyles, makeStyles } from '@mui/styles';
import ContextField from 'components/_shared/ContextField';

const useStyles = makeStyles(() =>
    createStyles({
        body: {
            position: 'relative',
            background: '#FBFBFF',
            borderRadius: '0 0 16px 16px',
            boxSizing: 'border-box',
            padding: '0 24px',
            width: '100%'
        },
        title: {
            boxSizing: 'border-box',
            fontSize: '24px',
            lineHeight: 1.25,
            margin: '0 0 8px',
            padding: '0 40px 52px',
            textAlign: 'center',
            width: '100%'
        },
        bodyItems: {
            position: 'relative',
            top: '-30px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px'
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: '#EBEBFF',
            borderRadius: '16px',
            color: '#1F2152',
            paddingTop: '64px'
        },
        photoContainer: {
            backgroundColor: '#FFFFFF',
            position: 'absolute',
            left: 'calc(50% - 50px)',
            top: '-48px',
            borderRadius: '50%',
            height: '100px',
            width: '100px',
            '& img': {
                borderRadius: '50%',
                height: '100%',
                objectFit: 'cover',
                width: '100%'
            }
        },
        errorText: {
            color: '#F5577A',
            fontSize: '14px',
            fontWeight: 700,
            marginTop: '16px',
            textAlign: 'center'
        },
        customCard: {
            backgroundColor: '#FFFFFF',
            borderRadius: '16px',
            boxShadow: '0px 8px 16px 4px rgba(0, 0, 0, 0.05)',
            margin: '0px 24px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '0px',
            width: 'calc(100% - 48px)'
        },
        subtext2: {
            fontSize: '14px',
            fontWeight: 300,
            marginBottom: '16px',
            textAlign: 'left',
            color: '#5A6A81'
        }
    })
);

type ReinstateFormBodyProps = {
    member: {
        id: number;
        name: string;
        photo: string;
        first_name?: string | null;
        pii_first_name?: string | null;
    };
    loading: boolean;
    errorText?: string;
    onSubmit: (setSuccess: (value: boolean) => void, description: string) => void;
    setSuccess: (value: boolean) => void;
    deploymentName?: string | null;
};

const ReinstateFormBody: React.FC<ReinstateFormBodyProps> = ({
    member,
    loading,
    errorText,
    onSubmit,
    setSuccess,
    deploymentName
}) => {
    const [context, setContext] = useState('');
    const classes = useStyles();
    const title = `Request Extension for ${member.first_name || member.pii_first_name || member.name}'s Membership`;
    const deploymentLabel = deploymentName?.trim() || 'this deployment';
    const note = `Please note that extensions are granted as determined by ${deploymentLabel} and are not guaranteed. Our team will process this request within 5-10 business days. Please reach out to support@samaritan.city with any questions.`;

    return (
        <div>
            <div className={classes.photoContainer}>
                <img src={member.photo} alt="profile" />
            </div>
            <div className={classes.content}>
                {title && <h2 className={classes.title}>{title}</h2>}
                <div className={classes.body}>
                    <div className={classes.bodyItems}>
                        <div className={classes.customCard}>
                            <span className={classes.subtext2}>{note}</span>
                            <ContextField
                                context={context}
                                handleModalClick={() => {}}
                                handleSubmit={() => onSubmit(setSuccess, context)}
                                loading={loading}
                                setContext={setContext}
                                canBeEmpty={true}
                                placeholderText="[Optional] Please feel free to share relevant details regarding this individual's Membership or extension request"
                            />
                            {errorText && <span className={classes.errorText}>{errorText}</span>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReinstateFormBody;